import ArchiveWinner from './Main'
import { getBaseMetaTitle } from '@/environments'

const route = {
  path: '/archive/winner',
  name: 'winnerArchive',
  meta: {
    title: `Archive - ${getBaseMetaTitle}`
  },
  component: ArchiveWinner
}

export default route
